import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

const footerLinks = {
  product: {
    title: '产品服务',
    links: [
      { label: '电脑软件', href: '/category/software' },
      { label: '热门游戏', href: '/category/games' },
      { label: '手机应用', href: '/category/apps' },
      { label: '最新上架', href: '/category/software' },
    ],
  },
  support: {
    title: '帮助支持',
    links: [
      { label: '下载帮助', href: '/article/art-001' },
      { label: '常见问题', href: '/about' },
      { label: '安装教程', href: '/article/art-002' },
      { label: '安全指南', href: '/article/art-005' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about' },
      { label: '用户口碑', href: '/about' },
      { label: '隐私政策', href: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-download-2-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-bold text-white">{siteInfo.name}</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              {siteInfo.tagline}。提供快速、安全、免费的下载服务，海量资源一键获取。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="B站">
                <i className="ri-bilibili-line text-white"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | {siteInfo.icp}
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span>{siteInfo.email}</span>
            <span className="hidden sm:inline">|</span>
            <span>{siteInfo.phone}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}